import { mergeStyles } from "@fluentui/merge-styles";
import { tokens } from "@fluentui/react-components";
import { FONT_SIZE_REGULAR } from '../../../config/fontSizes';

export const refreshBtnClass = mergeStyles({
  minWidth: 'unset',
  width: '24px',
  height: '24px',
  padding: '0',
  flexShrink: 0,
  color: tokens.colorBrandForeground1,
})

export const attachIconClass = mergeStyles({
  fontSize: '14px',
  color: tokens.colorNeutralForeground3,
  flexShrink: 0,
})

export const bubbleFooterClass = mergeStyles({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '4px',
  paddingTop: '2px',
  paddingBottom: '16px',
})

export const filedMetaClass = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: '1 1 0',
  minWidth: 0,
})

export const openIconClass = mergeStyles({
  position: 'absolute',
  bottom: 0,
  right: 0,
  paddingBottom: '4px',
  marginLeft: '4px',
  marginBottom: '4px',
  ":hover": {
    backgroundColor: "transparent !important",
    color: tokens.colorBrandForeground1,
  },
})

export const expandIconClass = mergeStyles({
  position: 'absolute',
  bottom: 0,
  right: '50%',
  backgroundcolour: 'transparent',
  padding: '2px',
  margin: '2px',
  width: '18px',
  height: '18px',
  alignItems: 'center',
  color: tokens.colorNeutralForeground3,
})


export const avatarRowClass = mergeStyles({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  width: '100%',
})

export const dateClass = mergeStyles({
  fontSize: '9pt',
  fontWeight: '400',
  color: 'grey',
  whiteSpace: 'nowrap',
})
export const nameClass = mergeStyles({
  textAlign: 'left',
  fontSize: '9pt',
  fontWeight: '400',
  color: 'grey',
})

export const dateNameContainerClass = mergeStyles({
  display: 'flex',
  justifyContent: 'space-between',
  flex: 1,
  minWidth: 0,
})

export const contentWarnClass = mergeStyles({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingTop: '4px',
  color: tokens.colorNeutralForeground3,
  fontSize: '8pt',
})

export const subjectClass = mergeStyles({
  paddingTop: '30px',
  color: tokens.colorNeutralForeground2,
  fontSize: FONT_SIZE_REGULAR,
  fontWeight: 'bold',
  textAlign: 'center',
})

export const underlineStyle = mergeStyles({
  paddingBottom: "10px",
  borderTop: "0.25px solid",
  borderColor: tokens.colorNeutralForeground4,
});

export const summaryBodyClass = mergeStyles({
  paddingBottom: "4px",
});

export const messageBubbleClass = (internalSender: boolean, selected = false) => mergeStyles({
  backgroundColor: internalSender ? '#f0f3f7' : '#edebe9',
  padding: '7px',
  borderRadius: '5px',
  position: 'relative',
  border: selected ? `1px solid ${tokens.colorBrandBackground}` : '1px solid transparent',
  transition: 'border-color 0.1s ease',
});

export const messageItemClass = (internalSender: boolean) => mergeStyles({
  position: 'relative',
  paddingLeft: internalSender ? '8%' : '0',
  paddingRight: internalSender ? '0' : '8%',
  overflow: 'hidden',
  boxSizing: 'border-box',
});

export const stackColumnGap10 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const emptyStateClass = mergeStyles({
  padding: 32,
  textAlign: "center",
  color: "#888",
});

export const stackContainerClass = mergeStyles({
  width: '100%',
  flex: 1,
  overflow: 'auto',
  boxSizing: 'border-box',
  minHeight: 0,
})

export const pageContainerClass = mergeStyles({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 48px)',
  overflow: 'hidden',
})

export const filedFolderClass = mergeStyles({
  fontSize: tokens.fontSizeBase200,
  color: tokens.colorNeutralForeground3,
  cursor: 'default',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  maxWidth: '100%',
  overflow: 'hidden',
  '& svg': {
    fontSize: '14px',
    flexShrink: 0,
  },
})

export const filedFolderPathClass = mergeStyles({
  maxWidth: '80%',
  minWidth: 0,
  flexShrink: 1,
})

export const filedFolderLabelClass = mergeStyles({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const filedFolderPathTextClass = mergeStyles({
  unicodeBidi: 'embed',
  direction: 'ltr',
})

export const fileReadBtnRowClass = mergeStyles({
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  justifyContent: 'center',
  alignItems: 'stretch',
  padding: '6px 8px 16px',
  backgroundColor: tokens.colorNeutralBackground1,
  borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
})

export const selectAllRowClass = mergeStyles({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 8px',
})


export const unreadTextClass = mergeStyles({
  fontWeight: 'bold',
})

export const unreadShortSummaryClass = mergeStyles({
  fontWeight: '600',
})

export const clickableShortSummaryClass = mergeStyles({
  cursor: 'pointer',
})

export const inlineFilingPanelClass = mergeStyles({
  borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
  backgroundColor: tokens.colorNeutralBackground1,
  flexShrink: 0,
  maxHeight: '55vh',
  overflowY: 'auto',
  boxSizing: 'border-box',
  position: 'relative',
})

export const filingPanelHeaderClass = mergeStyles({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: '4px',
  paddingTop: '2px',
})
